/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

function initLocaleOnLoad() {
  // Namespaced so the turbo:load pass doesn't stack a second handler on top of
  // the one $(ready) already bound.
  $('form.locale-switcher select').off('change.locale').on('change.locale', function() {
    // Scoped to this form: a page can carry more than one switcher (top plus
    // footer), so a document-wide lookup would fill in the wrong form's field.
    $(this.form).find('input[name="return_to"]').val(document.location);
    this.form.submit();
  });
}

$(initLocaleOnLoad);
document.addEventListener('turbo:load', initLocaleOnLoad);
